const ContactPagination = ({
    page,
    totalPages,
    onPageChange,
}) => {
    return (
        <div className="flex justify-center mt-4 gap-2">
            <button
                disabled={page === 1}
                onClick={() =>
                    onPageChange(page - 1)
                }
            >
                ◀ Trước
            </button>

            <span>
                Trang {page} / {totalPages}
            </span>

            <button
                disabled={page === totalPages}
                onClick={() =>
                    onPageChange(page + 1)
                }
            >
                Sau ▶
            </button>
        </div>
    );
};

export default ContactPagination;